<template>
    <section class="ontwikkeling title">
        <ogt-video ref="video" src="/static/video/introductie.mp4" poster="/static/video/introductie-poster.jpg"></ogt-video>
        <img src="/static/img/ogt-logo-diap.png" alt="" class="logo"/>
        <h1>Samen in ontwikkeling</h1>
        <h2>Jaaroverzicht 2020</h2>
    </section>
</template>

<style lang="scss" scoped>
    // see /static/scss/pages/_title.scss
</style>

<script>
    import { gsap } from '@/vendor';

    import OgtVideo from '@/app/components/OgtVideo';
    import Trots from '@/app/pages/ontwikkeling/Trots.vue';
    import Intro from '@/app/pages/ontwikkeling/Intro.vue';
    import Quote from '@/app/pages/ontwikkeling/Quote.vue';
    import Video from '@/app/pages/ontwikkeling/VideoEmbed.vue';

    export default {
        name: '',
        meta: {
            title: '1. Samen in ontwikkeling',
            color: '#a5147e',
            slides: [ Trots, Intro, Quote, Video ]
        },

        components: {
            'ogt-video': OgtVideo
        },

        mounted()
        {
            this.tl = gsap.timeline({ paused: true });
            this.tl.fromTo( 'section.ontwikkeling.title h1', { y: 20, autoAlpha: 0 }, { y: 0, autoAlpha: 1, duration: 0.5 }, 1 );
            this.tl.fromTo( 'section.ontwikkeling.title h2', { y: 20, autoAlpha: 0 }, { y: 0, autoAlpha: 1, duration: 0.5 }, 1.3 );
        },
        methods: {
            focus()
            {
                this.tl.play( 0 );
                this.$refs.video.play();
            },
            blur()
            {
                this.$refs.video.pause();
            }
        }
    };
</script>
